const styles = {
  body: {
    padding: "2em",
    backgroundColor: "white",
    font: "normal 12px/1.7 '굴림',Gulim,'돋움',Dotum,AppleGothic,Sans-serif",
  },
  hr: {
    margin: "2em 0",
  },
  ol: {
    padding: "0px",
    paddingLeft: "15px",
    margin: "0px",
  },
};

const Body = ({ children }) => {
  return <body style={styles.body}>{children}</body>;
};
const Hr = ({ children }) => {
  return <hr style={styles.hr}>{children}</hr>;
};
const Ol = ({ children }) => {
  return <ol style={styles.ol}>{children}</ol>;
};

const TermsPage = () => {
  return (
    <Body>
      <title>개인정보 수집 및 이용안내</title>
      <h2>개인정보 수집 및 이용안내</h2>
      <p>
        주식회사 비피앤솔루션(이하 “회사”라 함)은 정보통신망 이용촉진 및
        정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법,
        등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호
        규정을 준수하며, 관련 법령에 의거한 개인정보취급방침을 정하여 이용자
        권익 보호에 최선을 다하고 있습니다.
        <br />
        <br />
        "회사"는 개인정보 수집 및 이용약관을 통해 이용자들이 제공하는 개인정보가
        어떠한 용도와 방식으로 이용되고 있으며 정보보호를 위해 어떠한 조치가
        취해지고 있는지 알려드립니다. 회사의 개인정보 수집 및 이용약관은 정부의
        법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될
        수 있으며, 개인정보 수집 및 이용약관의 지속적인 개선을 위하여 필요한
        절차를 정하고 있습니다.
        <br />
        <br />
        "회사"는 고객의 사생활을 현저하게 침해할 우려가 있는 민감한
        개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및
        범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다. 다만, 서비스
        제공을 위해 일부 민감정보를 필요최소한으로 수집, 처리할 필요가 있는 경우
        관련 법령의 제한에 따라 고객의 동의 등 필요한 조치를 거쳐 개인정보를
        수집, 처리할 수 있습니다.
      </p>
      <Hr />
      <h3>제 1 조 (개인정보 수집)</h3>
      <p>
        "회사"는 회원가입, 고객상담, 각종 서비스 제공을 위해 필요한 최소한의
        개인정보를 수집하고 있습니다.
        <br />
        <b>- 이메일, 이름, 전화번호, 생년월일</b>
      </p>
      <p>
        서비스 이용과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수
        있습니다.
        <br />
        <b>- 접속 IP 정보, 서비스 이용기록, 방문 일시</b>
      </p>

      <Hr />

      <h3>제 2 조 (수집한 개인정보의 이용 및 처리)</h3>
      <p>
        회원관리, 서비스 제공·개선, 신규 서비스 개발 등을 위해 이용합니다.
        <br />
        회원 가입 시 또는 서비스 이용과정에서 애플리케이션을 통해 아래와 같이
        서비스 제공을 위한 필요한 최소한의 개인정보를 수집하고 있습니다.
      </p>
      <Ol>
        <li>회원 식별/가입의사 확인, 본인/연령 확인, 부정이용 방지</li>
        <li>
          만 14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 법정
          대리인 권리행사 시 본인 확인
        </li>
        <li>
          신규 서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만처리, 공지사항
          전달
        </li>
        <li>
          서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위 등
          포함)에 대한 방지 및 제재
        </li>
        <li>
          인구통계학적 특성과 이용자의 관심, 기호, 성향의 추정을 통한 맞춤형
          컨텐츠 추천 및 마케팅에 활용
        </li>
        <li>
          서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시
          보호 측면의 서비스 환경 구축, 서비스 개선에 활용
        </li>
      </Ol>

      <Hr />

      <h3>제 3 조 (개인정보 처리 및 보유기간)</h3>
      <p>
        "로지프로스트" 회원 탈퇴 시 정보주체의 개인정보를 지체없이 파기합니다.
      </p>

      <Hr />

      <h3>제 4 조 (개인정보의 제3자 제공)</h3>
      <p>
        "회사"는 개인정보를 [제 2 조 (수집한 개인정보의 이용 및 처리)]에서
        고지한 범위내에서 이용하여, 정보주체의 사전동의 없이는 동 범위를
        초과하여 이용하거나 원칙적으로 개인정보를 외부에 공개하지 않습니다.
        다만, 아래의 경우에는 예외로 합니다.
      </p>
      <Ol>
        <li>정보주체가 사전에 동의한 경우</li>
        <li>
          법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에
          따라 수사기관의 요구가 있는 경우
        </li>
        <li>
          통계처리, 학술연구, 시장조사 등을 위하여 필요한 경우로서 특정한 개인을
          식별할 수 없는 형태로 개인정보를 제공하는 경우
        </li>
        <li>
          정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여
          필요하다고 인정되는 경우
        </li>
        <li>
          회사가 법령상 의무를 준수하기 위하여 불가피하게 수집한 개인정보를 그
          수집 목적 내에서 제공하는 경우
        </li>
      </Ol>

      <Hr />

      <h3>제 5 조 (개인정보의 파기)</h3>
      <p>
        개인정보는 [제 2 조 (수집한 개인정보의 이용 및 처리 목적)]이 달성되면
        지체 없이 파기합니다. "회사"의 개인정보 파기 방법은 다음과 같습니다.
      </p>
      <Ol>
        <li>
          종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
        </li>
        <li>
          전자적 파일 형태로 저장된 개인정보는 기록을 재성할 수 없는 기술적
          방법을 사용하여 삭제합니다.
        </li>
      </Ol>

      <Hr />

      <h3>제 6 조 (이용자의 권리와 그 행사방법)</h3>
      <p>
        이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수
        있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나
        가입해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의
        일부 또는 전체 이용이 어려울 수 있습니다.
      </p>
      <p>
        이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기
        전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된
        개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체
        없이 통지하여 정정이 이루어지도록 하겠습니다.
      </p>

      <Hr />

      <h3>제 7 조 (개인정보의 기술적/관리적 보호 대책)</h3>
      <p>
        "회사"는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난,
        누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
        기술적/관리적 대책을 강구하고 있습니다.
      </p>
      <Ol>
        <li>
          개인정보의 암호화
          <br />
          회사는 관련 법률규정 또는 내부 정책에 따라 개인정보를 암호화하여
          안전하게 저장 및 관리하고 있습니다.
        </li>
        <li>
          해킹 등에 대비한 대책
          <Ol type="A">
            <li>
              회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가
              유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
            </li>
            <li>
              개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신
              백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나
              손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여
              네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
            </li>
            <li>
              침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
              있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든
              기술적 장치를 갖추려 노력하고 있습니다.
            </li>
          </Ol>
        </li>
      </Ol>

      <Hr />

      <h2>부칙</h2>
      <Hr />
      <h3>제 1 조 시행일</h3>
      <p>이 약관은 2021년 10월 01일부터 적용됩니다.</p>
    </Body>
  );
};

export default TermsPage;
